import React from "react";
import { PopupBlock } from "./styled";

const PopupTemplate = ({ contentFunction }) => {
  console.log(contentFunction);
  return (
    <PopupBlock>
      <PopupBlock.Window>{contentFunction()}</PopupBlock.Window>
    </PopupBlock>
  );
};

export default PopupTemplate;
